import { IBundleEntity } from 'multirpc-sdk';

import { ReferralProgram } from 'modules/strapi/types';

export interface FilterBonusBundlesParams {
  bundles: IBundleEntity[];
  referralPrograms: ReferralProgram[] | undefined;
}

export const filterBonusBundles = ({
  bundles,
  referralPrograms,
}: FilterBonusBundlesParams) =>
  bundles?.filter(bundle => {
    const isBonusBundle = referralPrograms?.some(
      program => program.bundleID === bundle.bundle.bundle_id,
    );

    return !isBonusBundle;
  }) ?? [];
